import executeRequest from "Infrastructure/WebClient";
import * as RequestTypes from "Application/RequestTypes";

type PaymentRequest = {
  url: string;
  method: string;
  type: string;
  data: Record<string, string>;
};

export function payPublic(token: string) {
  executeRequest(
    RequestTypes.GET_PAYMENT_PROVIDER_REQUEST_PUBLIC,
    {},
    { token: token }
  ).then((paymentRequest: any) => {
    handlePaymentRequest(paymentRequest);
  });
}
export function pay(paymentPlanId: string) {
  executeRequest(
    RequestTypes.GET_PAYMENT_PROVIDER_REQUEST,
    {},
    { id: paymentPlanId }
  ).then((paymentRequest: any) => {
    handlePaymentRequest(paymentRequest);
  });
}

function handlePaymentRequest(paymentRequest: PaymentRequest) {
  if (paymentRequest["type"] === "FORM") {
    executeFormPayment(paymentRequest);
  }
}

function executeFormPayment(paymentRequest: PaymentRequest) {
  var form = document.createElement("form");
  form.action = paymentRequest.url;
  form.method = paymentRequest.method;

  Object.keys(paymentRequest.data).forEach((field) => {
    var inputName = document.createElement("input");
    inputName.type = "hidden";
    inputName.name = field;
    inputName.value = paymentRequest.data[field];
    form.appendChild(inputName);
  });
  document.body.appendChild(form);
  form.submit();
}
